var EventsFilter = (function($) {
  var $els = {};
  var activeTags = [];
  var defaultState = true;

  var init = () => {
    _initDom();
    _addListeners();
  };

  var _initDom = () => {
    $els.tagBtns = $("label.btn-tag").not(".btn-tag--all");
    $els.allTagsBtn = $(".btn-tag--all");
    $els.eventItems = $(".event");
    $els.inputs = $("[data-target-tag]").not("[data-target-tag='all']");
    $els.dayNav = $("#eventTabs");
    $els.dayNavItems = $els.dayNav.find(".nav-link");
    $els.dayNavLabel = $(".sticky-nav .day");
    $els.dayNavBack = $(".sticky-nav .back");

    // console.log ( '_initDom' );

    // get the sticky element
    const stickyElm = document.querySelector(".sticky-nav");

    const observer = new IntersectionObserver(
      ([e]) => {
        let rectTop = e.intersectionRect.top;
        let screenHalf = window.innerHeight * 0.5;
        // console.log("scroll - ", window.scrollY);
        // console.log("rect top - ", e.intersectionRect.top);
        // console.log("screen height - ", window.innerHeight / 2);
        if (rectTop > screenHalf || window.scrollY === 0) return;
        e.target.classList.toggle("is-sticky", e.intersectionRatio < 1)
      }, { threshold: [1] }
    );

    observer.observe(stickyElm);

    _setDefaultState();
  };

  var _addListeners = () => {
    $els.allTagsBtn.on("click", e => {
      e.preventDefault();
      e.stopPropagation();
      _setDefaultState();
    });

    $els.tagBtns.on("click", e => {

      console.log ( 'tagBtns.click' );
      var $this = $(e.target);
      var $input = $this.find("input");
      var isChecked = $input.is(":checked");
      var targetTag = $input.data("target-tag");

      if (defaultState === true) {
        // first click on a category - deactivate the 'all' button
        $els.allTagsBtn.removeClass("active");
        activeTags = [];
        defaultState = false;
      }

      if (!isChecked) {
        // add to active
        activeTags.push(targetTag);

        if (activeTags.length === $els.inputs.length) {
          // all items manually selected, revert to default
          _setDefaultState();
        } else {
          _updateActiveItems();
        }
      } else {
        // remove from active
        var targetIndex = activeTags.indexOf(targetTag);
        if (targetIndex > -1) {
          activeTags.splice(targetIndex, 1);

          if (activeTags.length === 0) {
            // revert to default
            _setDefaultState();
          }
        }
        _updateActiveItems();
      }
    });

    $els.dayNavItems.on("click", e => {
      let dayName = $(e.target)
        .text()
        .split(",")[0];
      $els.dayNavLabel.text(dayName);
    });

    $els.dayNavBack.on("click", e => {
      $([document.documentElement, document.body]).animate(
        { scrollTop: $els.dayNav.offset().top - 25 },
        200
      );
    });
  };

  var _setDefaultState = () => {
    activeTags = [];
    defaultState = true;
    $els.allTagsBtn.addClass("active");

    $.each($els.inputs, function(i, val) {
      activeTags.push($(val).data("target-tag"));
    });

    $.each($els.tagBtns, function(i, val) {
      setTimeout(() => {
        $(val)
          .removeClass("active")
          .removeClass("focus");
        $els.inputs.prop("checked", false);
      }, 100);
    });

    // check if any untagged items
    // var hasUntaggedItems = $('[data-tags*="untagged"]').length > 0;

    // if (hasUntaggedItems) {
    //   $("label.untagged")
    //     .removeClass("d-none")
    //     .find("input")
    //     .attr("checked", "checked");
    // } else {
    //   // remove untagged since we don't have any
    //   var index = activeTags.indexOf("untagged");
    //   if (index > -1) {
    //     activeTags.splice(index, 1);
    //   }
    // }

    _updateActiveItems();
  };

  var _updateActiveItems = () => {
    $els.eventItems.hide();

    $.each(activeTags, function(i, val) {
      var $itemsToAdd = $els.eventItems.filter('[data-tags*="' + val + '"]');
      $itemsToAdd.show();
    });
  };

  module.exports = {
    init: init
  };
})(jQuery);
